export default function ({ env }, inject) {
  inject('secure3dEnv', env.secure3dEnv)
}
